// extracted by mini-css-extract-plugin
export var closeButton = "_pd-2";
export var closeButtonIcon = "_pd-3";
export var lightboxContent = "_pd-1";
export var lightboxOverlay = "_pd-0";